import React, {Component} from 'react';
import leftSideIcon from "../../../components/image/leftside.png";

class FloatDefaultTool extends Component {

    onClick = ()=>{
        this.props.editor.execCommand("imagefloat", "none");
    };

    getName(){
        return "floatDefaultTool"
    }

    render() {
        return (
            <span>
                <img src={leftSideIcon} onClick={()=>{this.onClick()}}/>
            </span>
        );
    }
}

export default FloatDefaultTool;